import React from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import NavigationTabs from '../navigation_tabs/NavigationTabs';
import SMSCampaign from '../sms_campaign/SMSCampaign';
import Contacts from '../contacts/Contacts';
import Details from '../details/Details';
import TEXTS from '../../locale/texts.json';

const Dashboard = ({ match, lang, accessPermissions }) => {
  const { cabinetAccess, detailsAccess } = accessPermissions;
  // make binary from accessPermissions
  // and then convert from binary to integer
  // flags var can be 0, 1, 2, 3
  const flags = parseInt(`${+!!cabinetAccess}${+!!detailsAccess}`, 2);

  // if is 2 ('10' binary, only cabinetAccess) or 0 ('00' binary)
  let tabs = [{
    component: SMSCampaign,
    to: 'sms-campaigns',
    title: TEXTS.tabNameSmsCampaign[lang]
  }, {
    component: Contacts,
    to: 'phonebook',
    title: TEXTS.tabNamePhoneBook[lang]
  }];

  const tabDetails = {
    component: Details,
    to: 'details',
    title: TEXTS.tabNameDetails[lang]
  };

  // 01 (binary) - only detailsAccess
  if (flags === 1) {
    tabs = [tabDetails];
  }

  // 11 (binary) - both
  if (flags === 3) {
    tabs = [...tabs, tabDetails];
  }
  
  return(
    <div>
      <NavigationTabs
        match={match}
        tabs={tabs}
      />
      <Switch>
        <Route exact path="/">
          <Redirect to="/sms-campaigns" />
        </Route>
      </Switch>
    </div>
  );
};

export default withRouter(Dashboard);
